import { render } from "./PolicyProvisionImportModal.vue?vue&type=template&id=611d87c0&scoped=true"
import script from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"
export * from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"

import "./PolicyProvisionImportModal.vue?vue&type=style&index=0&id=611d87c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611d87c0"]])

export default __exports__